import { useEffect, useState } from 'react';
import './music-button.scss';
import clsx from 'clsx';
import audioController from '../../utils/audio-controller';
export default function MusicButton() {
  const [isPaused, setIsPaused] = useState(true);
  const onToggleMusic = () => {
    const musicState = !isPaused;
    setIsPaused(musicState);
  };

  useEffect(() => {
    if (isPaused) {
      audioController.setEnabled(false);
    } else {
      audioController.setEnabled(true);
    }
  }, [isPaused]);

  useEffect(() => {
    const autoPlayMusic = () => {
      setIsPaused(false);
      if (audioController.playing('bgm')) return;
      audioController.play('bgm');
    };
    document.addEventListener('pointerdown', autoPlayMusic, { once: true });
    return () => {
      document.removeEventListener('pointerdown', autoPlayMusic);
    };
  }, []);

  return (
    <div
      className={clsx(
        'music_button cursor-pointer',
        isPaused && 'music_button_paused'
      )}
      onClick={onToggleMusic}
    ></div>
  );
}
